<template>
	<modal
		size="small-medium"
		class="modal-display"
		:hide-footer="true"
		@close="close">
		<template slot="header">
			<h3>{{ $t('Send us some feedback') }}!</h3>
		</template>
		<template slot="body">
            <label class="mb-4">{{ $t('Please use this feedback form to let us know if you encounter some problem, suggestion or other information that you would like to share with us') }}</label>
			<form @submit.prevent="save">
				<!-- Name -->
				<div class="text-left">
					<label>{{ $t('But first, what is your opinion about Grafias?') }}?</label>
                    <div class="text-left">
                        <!-- mood 1 -->
                        <span @click="selectMood1">
                            <md-icon v-if="!isMood1" class="icon-list-feedback mr-3 pointer">sentiment_very_dissatisfied</md-icon>
                        </span>
                        <span @click="selectMood1">
                            <md-icon v-if="isMood1" class="icon-list-1-feedback mr-3 pointer" @click="selectMood1">sentiment_very_dissatisfied</md-icon>
                        </span>
                        <!-- mood 2 -->
                        <span @click="selectMood2">
                            <md-icon v-if="!isMood2" class="icon-list-feedback mr-3 pointer" @click="selectMood2">sentiment_dissatisfied</md-icon>
                        </span>
                        <span @click="selectMood2">
                            <md-icon v-if="isMood2" class="icon-list-2-feedback mr-3 pointer" @click="selectMood2">sentiment_dissatisfied</md-icon>
                        </span>
                        <!-- mood 3 -->
                        <span @click="selectMood3">
                            <md-icon v-if="!isMood3" class="icon-list-feedback mr-3 pointer" @click="selectMood3">sentiment_satisfied</md-icon>
                        </span>
                        <span @click="selectMood3">
                            <md-icon v-if="isMood3" class="icon-list-3-feedback mr-3 pointer" @click="selectMood3">sentiment_satisfied</md-icon>
                        </span>
                        <!-- mood 4 -->
                        <span @click="selectMood4">
                            <md-icon v-if="!isMood4" class="icon-list-feedback mr-3 pointer" @click="selectMood4">sentiment_very_satisfied</md-icon>
                        </span>
                        <span @click="selectMood4">
                            <md-icon v-if="isMood4" class="icon-list-4-feedback mr-3 pointer" @click="selectMood4">sentiment_very_satisfied</md-icon>
                        </span>
                    </div>
				</div>
                <!-- Category Feedback -->
                <!-- <div class="flex-center mt-6 hidden">
                    <div class="card mb-3" @click="selectCategory1" v-bind:class="{'orange-category': isCategory1, 'original-category': !isCategory1}">
                        <div class="card-body feedback-choice">
                            <div class="justify-content">
                                <div class="mt-3">
                                    {{ $t('Suggestion') }}
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="card mb-3" @click="selectCategory2" v-bind:class="{'orange-category': isCategory2, 'original-category': !isCategory2}">
                        <div class="card-body feedback-choice">
                            <div class="justify-content-between">
                                <div>
                                    {{ $t('Something is not quite right') }}
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="card mb-3" @click="selectCategory3" v-bind:class="{'orange-category': isCategory3, 'original-category': !isCategory3}">
                        <div class="card-body feedback-choice">
                            <div class="justify-content-between">
                                <div class="mt-3">
                                    {{ $t('Compliment') }}
                                </div>
                            </div>
                        </div>
                    </div>
                </div> -->
                <div class="form-group mb-4 mt-6">
                    <label>{{ $t('Your Feedback') }}</label>
                    <!-- <md-field>
                        <md-textarea v-model="feedback" required></md-textarea>
                    </md-field> -->
                    <textarea class="textarea-feedback" rows="8" cols="68" v-model="feedback">
                    </textarea>
                </div>
				<label class="text-white underline mr-1 pointer" to="/help">{{ $t('Click Here') }}
				<input type="file" class="hidden" ref="updateInput" accept=".png,.gif,.jpeg,.jpg,.mp4,.mpg,.m4v,.webm" @change="onSelectAttachment" id="attachment-homepage">
				</label>
				{{$t('to attach file, if there is a screenshot, video recording to help us improve your experience ')}}
				<div class="pt-3">
					<div>{{ $t('Attachments') }}:</div>
					<div class="text-left absolute" v-if="isUpload">
						<div class="is-loading large"></div>
					</div>
					<span v-if="dataAttachment" class="text-grey">{{dataAttachment.name}}</span>
					<span v-else class="text-grey">-</span>
				</div>
				<!-- <div class="modal-actions mt-6 mb-3 text-right">
					<button
						:disabled="valid"
						type="submit"
						class="btn btn-submit btn-primary"
						:class="{ 'is-loading': isSaving }">
						<span>{{ $t('Send Feedback') }}</span>
					</button>
				</div> -->
			</form>
		</template>
	</modal>
</template>

<script>
import Modal from '@/components/Modal.vue';
import { getAxiosErrorMessage } from '@/lib/helper';
import feedbacksApi from '@/api/feedbacks';
import fileApi from '@/api/file';

export default {
	name: 'ModalSendFeedback',
	props: {
		data: {
			type: Object,
		},
	},
	components: {
		Modal,
	},
	data() {
		return {
			name: '',
			feedback: '',
			title: '',
			category: '',
			moodLevel: '',
			isSaving: false,
			isMood1: false,
			isMood2: false,
			isMood3: false,
			isMood4: false,
			isCategory1: false,
			isCategory2: false,
			isCategory3: false,
			dataAttachment: null,
			isUpload: false,
		};
	},
	methods: {
		save() {
			this.isSaving = true;
			const params = this.params;
			const callback = (response) => {
				const feedback = response.data;
				this.$emit('saved', feedback);
				this.$notify({
					group: 'app',
					type: 'success',
					title: 'Display',
					text: 'Thank you for your feedback, we really appreciate it.',
				});
				this.isSaving = false;
				this.close();
			};
			const errorCallback = (e) => {
				const message = getAxiosErrorMessage(e);
				this.$notify({
					group: 'app',
					type: 'error',
					title: 'Feedback',
					text: message,
				});
				this.isSaving = false;
			};
			feedbacksApi.create(params, callback, errorCallback);
		},
		close() {
			this.$emit('close');
		},
		initData() {
			this.reset();
		},
		reset() {
			this.feedback = '';
			this.title = '';
			this.moodLevel = false;
			this.category = '';
		},
		setData(data) {
			this.name = data.name;
			this.description = data.description;
			this.isActive = data.is_active;
			this.isDefault = data.is_default;
			this.size = data.display_size_id;
			this.isTransparent = data.is_transparent;
			this.isPreload = data.is_preload;
			this.indexFilter = data.layer_index;
		},
		selectMood1() {
			this.isMood1 = true;
			this.isMood2 = false;
			this.isMood3 = false;
			this.isMood4 = false;
			this.moodLevel = 1;
		},
		selectMood2() {
			this.isMood1 = false;
			this.isMood2 = true;
			this.isMood3 = false;
			this.isMood4 = false;
			this.moodLevel = 2;
		},
		selectMood3() {
			this.isMood1 = false;
			this.isMood2 = false;
			this.isMood3 = true;
			this.isMood4 = false;
			this.moodLevel = 3;
		},
		selectMood4() {
			this.isMood1 = false;
			this.isMood2 = false;
			this.isMood3 = false;
			this.isMood4 = true;
			this.moodLevel = 4;
		},
		selectCategory1() {
			this.isCategory1 = true;
			this.isCategory2 = false;
			this.isCategory3 = false;
			this.category = 'Suggestion';
		},
		selectCategory2() {
			this.isCategory1 = false;
			this.isCategory2 = true;
			this.isCategory3 = false;
			this.category = 'Something is not quite right';
		},
		selectCategory3() {
			this.isCategory1 = false;
			this.isCategory2 = false;
			this.isCategory3 = true;
			this.category = 'Compliment';
		},
		onSelectAttachment(event) {
			const files = event.target.files;
			if (files.length > 0) {
				if (files[0].type === 'image/jpeg' || files[0].type === 'image/gif' || files[0].type === 'image/png' || files[0].type === 'image/jpg' || files[0].type === 'video/mp4' || files[0].type === 'mpg' || files[0].type === 'm4v' || files[0].type === 'webm') {
					this.isUpload = true;
					const file = files[0];
					// Generate Params
					const uploadParams = new FormData();
					uploadParams.append('file', file);
					uploadParams.append('is_resize', 0);

					const callback = () => {
						// const fileName = this.file.name;
						this.dataAttachment = files[0];
						this.isUpload = false;
					};
					// eslint-disable-next-line no-unused-vars
					const errorCallback = (e) => {
						// eslint-disable-next-line
						this.isUpload = false;
					};
					const progresCallback = () => {
					};
					// Upload
					fileApi.upload(uploadParams, callback, errorCallback, progresCallback);
				} else {
					this.$notify({
						group: 'app',
						type: 'warning',
						title: 'Upload Media',
						text: 'Unsupported file',
					});
					// eslint-disable-next-line
					return;
				}
			}
		},
		removeAttachment(index) {
			this.dataAttachment.splice(index, 1);
		},
	},
	computed: {
		params() {
			const params = {
				title: 'Feedback',
				description: this.feedback,
				mood_level: this.moodLevel,
				file_path: this.dataAttachment,
			};
			return params;
		},
		valid() {
			return !(this.moodLevel && this.feedback);
		},
	},
	created() {
		this.initData();
	},
};
</script>
